import globalMU from "globalMU";
import {Situacao as SituacaoCapacidadeCarga} from '../components/finalizar-orcamento/disponibilidade-capacidade-de-carga/Situacao'
import { ExecutorServico, ResponsaveisServicoAgregado } from "app/components/servicos-agregados-responsaveis/ResponsaveisServicosAgregados";

export type TipoInconsistencia = {
  Cor: string;
  DescricaoTipo: string;
  Inconsistencias: Inconsistencia[]
  Tipo: "ERRO" | "ALERTA" | "PERGUNTA" | "PENDENCIA" | "ADVERTENCIA"
  UserMessage: string;
};

export type Inconsistencia =  {
  Autorizado: boolean;
  Codigo: string;
  Cor: string;
  DescricaoTipo: string;
  MensagemLiberacao: string;
  MensagemUsuario: string;
  Modulo: string;
  MotivoObrigatorio: boolean;
  Resposta: boolean;
  Tipo: number;
  UserMessage: string;
}

export type Situacao = {
  Codigo: 6 | 1 | 5
  Descricao: "Apenas Orçamento" | "Orçamento Confirmado" | "Apenas Confirmado" | "Enviar para Supervisão"
  Situacao: "A" | "1" | "5"
}

const situacoesOrcamento : Situacao[] = [
  {
    Codigo: 1,
    Descricao: "Orçamento Confirmado",
    Situacao: "1"
  },
  {
    Codigo: 6, 
    Descricao: "Apenas Orçamento",
    Situacao: "A"
  },
  {
    Codigo: 5,
    Descricao: "Enviar para Supervisão",
    Situacao: "5"
  },
  {
    Codigo: 1,
    Descricao: "Apenas Confirmado",
    Situacao: "1"
  }
]

export function obterSituacao({
  descricao, codigo, situacao
}: {descricao?:Situacao["Descricao"], codigo?: Situacao["Codigo"], situacao?:Situacao["Situacao"]}) : Situacao {
  return situacoesOrcamento.find(s => (globalMU.isNotNullOrEmpty(codigo) && s.Codigo == codigo)
    || (globalMU.isNotNullOrEmpty(descricao) && s.Descricao == descricao) 
    || (globalMU.isNotNullOrEmpty(situacao) && s.Situacao == situacao))
}

export type DadosFinalizar = {
  DadosFinalizarOrcamento: DadosFinalizarOrcamento,
  Ip: "string"
  TurnosEntrega: TurnosEntrega[],
  ComandaFreteLoja: boolean
}

export type DadosFinalizarOrcamento = {
  FilialCapacidadeCarga?:string;
  Roteiro?:string;
  DataPrevista?:string;
  DataPrevisaoEntregaCalendario?:string;
  DataMarcadaEntrega?:string;
  DataPrevisaoEntrega?:string;
  NovaDataPrevisaoEntrega?:string;
  IdentificadorOrcamento?:string;
  Inconsistencias?:TipoInconsistencia[];
  MotivoLiberacaoPendencia?:string;
  ObrigatorioInformarMotivoLiberacaoPendencias?:boolean;
  PossuiErros?:boolean;
  PossuiPendencias?:boolean;
  PossuiPerguntas?:boolean;
  SenhaLiberacaoPendencia?:string;
  SequencialAlteracao?:number;
  Situacao?:number;
  Situacoes?:Situacao[];
  CalendarioCapacidadeCarga?:boolean;
  DataEncaixeCapacidadeCarga?:string[];
  UserMessage?:string;
  ValidacaoCapacidadeCargaItens?: {
    IdentificadorItem: number
    SituacaoValidacaoCapacidadeCarga: SituacaoCapacidadeCarga
  }[]
  ExibirSelecaoFuncionarioResponsavelExecucaoServicoAgregado: boolean;
  ExibirTaxaIssServicoAgregado: boolean;
  ListaExecutores: ExecutorServico[];
  ServicosAgregadosDados: ResponsaveisServicoAgregado[];
};

export type CalendarioCapacidadeCarga = {
  data: string;
  backgroundcolor: string;
  color: string;
  UserMessage: string;
};

export type ConfirmarNovaData = {
  FilialCapacidadeCargaEncaixe: string;
  dataPrevisaoEntrega: string;
};

export type PesquisarDisponibilidadeCarga = {
  date: string;
  dataPrevista: string;
  filial: string;
  roteiro: string;
};

export type LiberarPendencia = {
  motivoLiberacaoPendencia: string;
  senhaLiberacaoPendencia: string;
};


export type TurnosEntrega = {
  Description: string,
  Value: string
}

export type CodigoPergunta = string
export type RespostaPergunta = boolean